import React from 'react';
import './Benefits.css';

function Benefits() {
  return (
    <div className="benefits-container">
      <h2 className="benefits-title">What You'll Get Inside</h2>
      <div className="benefits-list">
        <div className="benefit-item">
          <span className="checkmark">✓</span>
          <div className="benefit-content">
            <strong>Early Access</strong> to our private beta—play with new features first.
          </div>
        </div>

        <div className="benefit-item">
          <span className="checkmark">✓</span>
          <div className="benefit-content">
            <strong>Personalized Roadmap</strong> turning 27 tabs of other women's experiences into a step by step plan.
          </div>
        </div>

        <div className="benefit-item">
          <span className="checkmark">✓</span>
          <div className="benefit-content">
            <strong>Money-Savers</strong> crowdsourced from women who shaved $2K+ off their bills.
          </div>
        </div>

        <div className="benefit-item">
          <span className="checkmark">✓</span>
          <div className="benefit-content">
            <strong>Zero-Judgment Community</strong> moderated by certified fertility counselors.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Benefits; 